import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'util/currency';

const OrderTotalInfo = ({ orderTotal, chargeAmount, currency }) => {
  const { t } = useTranslation();

  const charges =
    orderTotal?.chargeSummary?.charges?.map(
      ({ chargeDescription, chargeApplied }) => ({
        value: chargeApplied,
        description: chargeDescription,
      }),
    ) ?? [];

  const taxes =
    orderTotal?.taxSummary?.taxes?.map(
      ({ taxDescription, taxAmountApplied }) => ({
        value: taxAmountApplied,
        description: taxDescription,
      }),
    ) ?? [];

  const orderTotals = [
    {
      value: orderTotal?.subtotal,
      description: t('drawer.refundDrawer.subtotal'),
    },
    {
      value: orderTotal?.gratuity,
      description: t('drawer.refundDrawer.tip'),
    },
    ...taxes,
    ...charges,
    {
      value: chargeAmount,
      description: t('drawer.refundDrawer.total'),
    },
  ];

  return (
    <Stack spacing={1}>
      {orderTotals.map(({ value, description }, index) => (
        <Box display="flex" justifyContent="space-between" key={index}>
          <Typography sx={{ fontWeight: 'bold' }}>{description}</Typography>
          <Typography sx={{ fontWeight: 'bold' }}>
            {formatCurrency(value, currency)}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
};

export default OrderTotalInfo;
